import { useEffect } from 'react';
import { Button } from 'antd';
import { Fire } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { canAccessAdminWeb, useSession } from '../auth/session';
import { memberPrivacyPolicy } from '../features/privacy/memberPolicyContent';
import { tokens } from '../theme';

function formatEffectiveDate(iso: string): string {
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) return '';
  return parsed.toLocaleDateString('vi-VN', {
    timeZone: 'Asia/Ho_Chi_Minh',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function PrivacyPolicyPage() {
  const navigate = useNavigate();
  const session = useSession((state) => state.session);
  const signedIn = canAccessAdminWeb(session);

  useEffect(() => {
    const previous = document.title;
    document.title = memberPrivacyPolicy.title;
    return () => {
      document.title = previous;
    };
  }, []);

  const effective = formatEffectiveDate(memberPrivacyPolicy.effectiveFrom);

  return (
    <div style={{ minHeight: '100vh', background: tokens.color.canvas }}>
      <header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          minHeight: tokens.layout.topbarHeight,
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          padding: '10px 20px',
          background: tokens.color.surface,
          borderBottom: `1px solid ${tokens.color.line}`,
        }}
      >
        <span
          aria-hidden
          style={{
            width: 36,
            height: 36,
            flex: 'none',
            borderRadius: tokens.radius.control,
            background: tokens.color.green,
            display: 'grid',
            placeItems: 'center',
            color: '#fff',
          }}
        >
          <Fire size={20} weight="fill" />
        </span>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 15, fontWeight: 700, letterSpacing: '-0.01em' }}>Chính sách dữ liệu</div>
          <div style={{ fontSize: 11, color: tokens.color.ink3 }}>App thành viên</div>
        </div>
        {signedIn && (
          <Button
            type="primary"
            size="large"
            style={{ marginLeft: 'auto' }}
            onClick={() => navigate('/')}
          >
            Vào bảng điều khiển
          </Button>
        )}
      </header>

      <main
        style={{
          maxWidth: 720,
          margin: '0 auto',
          padding: `${tokens.space.sectionGap}px 20px 48px`,
        }}
      >
        <h1
          style={{
            fontSize: 22,
            fontWeight: 700,
            letterSpacing: '-0.02em',
            margin: '8px 0 8px',
            color: tokens.color.ink,
          }}
        >
          {memberPrivacyPolicy.title}
        </h1>
        <p style={{ margin: '0 0 20px', fontSize: 13, lineHeight: 1.55, color: tokens.color.ink2 }}>
          Phiên bản {memberPrivacyPolicy.code}
          {effective ? ` · Áp dụng từ ${effective}` : ''}
        </p>

        <section
          aria-live="polite"
          style={{
            background: tokens.color.surface,
            border: `1px solid ${tokens.color.line}`,
            borderRadius: tokens.radius.container,
            boxShadow: tokens.shadow.card,
            padding: tokens.space.sectionGap,
          }}
        >
          <div
            style={{
              margin: 0,
              whiteSpace: 'pre-wrap',
              fontSize: 13,
              lineHeight: 1.55,
              color: tokens.color.ink,
            }}
          >
            {memberPrivacyPolicy.content}
          </div>
        </section>
      </main>
    </div>
  );
}
